// FormOwner.js - Composant Formulaire
import React, {useEffect, forwardRef, useImperativeHandle} from 'react';
import FloatLabel from "../FloatLabel";
import {Form, Input} from "antd";

const FormOwner = forwardRef(({owner, user, onSubmitSuccess, onSubmitError}, ref) => {
  const [form] = Form.useForm();

  // Exposer la fonction submit au composant parent
  useImperativeHandle(ref, () => ({
    submit: () => {
      form.submit();
    }
  }));

  // Mettre à jour les valeurs quand owner change
  useEffect(() => {

    // Réinitialiser complètement le formulaire avant de définir les nouvelles valeurs
    form.resetFields();

    form.setFieldsValue({
      name: user?.nom || `${owner?.proprietaire_personne?.personne_nom} ${owner?.proprietaire_personne?.personne_prenom}` || '',
      email: user?.email || owner?.proprietaire_personne?.personne_email1 || '',
      password: '',
      password_confirmation: '',
    });
  }, [owner, user, form]);

  const onFinish = (values) => {
    //console.log('Success:', values);
    // Appeler la fonction de succès du parent
    if (onSubmitSuccess) {
      onSubmitSuccess(values);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    // Appeler la fonction d'erreur du parent
    if (onSubmitError) {
      onSubmitError(errorInfo);
    }
  };

  return (
    <>
      <h3>Compte de l'utilisateur</h3>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        initialValues={{
          remember: true,
          name: `${owner?.proprietaire_personne?.personne_nom} ${owner?.proprietaire_personne?.personne_prenom}` || '',
          email: owner?.proprietaire_personne?.personne_email1 || ''
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <FloatLabel
          label="Propriétaire"
          name="name"
          value={form.getFieldValue('name')}
        >
          <Form.Item
            name="name"
            rules={[{required: true, message: 'Saisir un nom!'}]}
          >
            <Input/>
          </Form.Item>
        </FloatLabel>

        <FloatLabel
          label="Adresse Email"
          name="email"
          value={form.getFieldValue('email')}
        >
          <Form.Item
            name="email"
            rules={[{required: true, message: 'Saisir une adresse email!'}]}
          >
            <Input/>
          </Form.Item>
        </FloatLabel>

        <FloatLabel
          label="Mot de passe"
          name="password"
          value={form.getFieldValue('password')}
        >
          <Form.Item
            name="password"
            rules={[
              {required: !user, message: 'Saisir un mot de passe'},
              {min: 8, message: 'Le mot de passe doit contenir au moins 8 caractères minimum'}
            ]}
          >
            <Input.Password autoComplete="new-password"/>
          </Form.Item>
        </FloatLabel>

        <FloatLabel
          label="Confirmer le mot de passe"
          name="password_confirmation"
          value={form.getFieldValue('password_confirmation')}
        >
          <Form.Item
            name="password_confirmation"
            rules={[
              {required: !user, message: 'Confirmer le mot de passe'},
              {min: 8, message: 'Le mot de passe doit contenir au moins 8 caractères'},
              ({getFieldValue}) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Les mots de passe ne correspondent pas'));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password"/>
          </Form.Item>
        </FloatLabel>
      </Form>
    </>
  );
});

FormOwner.displayName = 'FormOwner';

export default FormOwner;